// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__4HajP","tooltip__button":"Tooltip_tooltip__button__I1K7z","tooltip__text":"Tooltip_tooltip__text__386Kc"};